import { WifiOff, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { RETRY } from "@/lib/uiMessages";

interface OfflineBannerProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

/**
 * Pasek pokazywany u góry strony, gdy przeglądarka zgłasza brak internetu.
 * Pozwala ponownie spróbować pobrać dane bez przeładowywania strony.
 */
export const OfflineBanner = ({ onRetry, isRetrying }: OfflineBannerProps) => {
  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-[60] bg-amber-50 border-b border-amber-200 text-amber-900"
    >
      <div className="max-w-screen-2xl mx-auto px-4 py-2 flex items-center gap-3 text-sm">
        <WifiOff className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <span className="flex-1">
          Brak połączenia z internetem. Sprawdź sieć i spróbuj ponownie.
        </span>
        <Button
          size="sm"
          variant="outline"
          onClick={onRetry}
          disabled={isRetrying}
          className="gap-1.5 h-8 bg-white"
        >
          <RefreshCw
            className={`h-3.5 w-3.5 ${isRetrying ? "animate-spin" : ""}`}
          />
          {RETRY}
        </Button>
      </div>
    </div>
  );
};
